package horcrux.frontend.common.views.components.input

import horcrux.frontend.common.State
import horcrux.frontend.common.views.components.containers.HStack
import mui.material.Slider
import mui.material.Stack
import mui.material.StackDirection
import mui.system.PropsWithSx
import mui.system.responsive
import mui.system.sx
import react.FC
import react.Props
import react.dom.html.ReactHTML.p
import web.cssom.JustifyContent

external interface SliderWithHelpProps<Value> : PropsWithSx {
    var id: String
    var label: String
    var min: Number
    var max: Number
    var step: Number
    var valueState: State<Value>
    var marksSupplierMaybe: (() -> dynamic)?
    var helpText: String
}

fun <Value> sliderWithHelp(toValue: (Number) -> Value, toNumber: (Value) -> Number): FC<SliderWithHelpProps<Value>> =
    FC { props ->
        p { +props.label }
        HStack {
            this.sx {
                this.justifyContent = JustifyContent.center
                +props.sx
            }
            Slider {
                this.min = props.min
                this.max = props.max
                this.step = props.step
                props.marksSupplierMaybe?.let { this.marks = it() }
                this.valueLabelDisplay = "auto"
                this.value = toNumber(props.valueState.get())
                this.onChange = { _, newValue, _ ->
                    props.valueState.set(toValue(newValue as Number))
                }
            }

            InfoPopover {
                this.id = "${props.id}-help"
                this.text = props.helpText
            }
        }
    }
